import React, { useMemo } from 'react';

import styles from './styles.module.scss';
import { Node as NodeType } from './types';
import { formatSubtitle, isMatchQuery, isSubtitleDefined } from './utils';

const Node = ({ nodeDatum, query }: any) => {
  const subtitle = nodeDatum.attributes?.subtitle;
  const variant: NodeType['variant'] =
    nodeDatum.attributes?.variant || 'default';

  const isHighlighted = useMemo(
    () =>
      query.length > 0 &&
      isMatchQuery(query, nodeDatum.name, subtitle.split(',')),
    [nodeDatum.name, subtitle, query],
  );

  const variantClass = {
    default: styles.VariantDefault,
    success: styles.VariantSuccess,
    warning: styles.VariantWarning,
    error: styles.VariantError,
  }[variant];

  return (
    <foreignObject width="500" height="500" x="-110" y="-50">
      <div
        className={`${styles.Container} ${isHighlighted && styles.Highlighted}`}
      >
        <div className={`${styles.Content} ${variantClass}`}>
          <span className={styles.Title}>{nodeDatum.name}</span>
        </div>
        {isSubtitleDefined(subtitle) && (
          <div className={styles.SubtitleContainer}>
            <ul className={`${variant !== 'default' && styles.RemoveBullets}`}>
              {subtitle.split(',').map((text: string) => (
                <li key={text} className={styles.Subtitle}>
                  {formatSubtitle(text)}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </foreignObject>
  );
};

export default Node;
